import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {TokenModel} from '../../../models/authentication/token.model';
import {UserService} from '../../../services/user/user.service';
import {ErrorModel} from '../../../models/shared/error.model';
import {ModalService} from '../../../shared/modals/modal/modal.service';
import {UserModel} from '../../../models/authentication/user.model';
import {TranslateService} from '@ngx-translate/core';
import {CultureModel} from '../../../models/localization-and-pricing/culture.model';
import {StringExtensionModel} from '../../../models/extensions/string-extension.model';
import {CountryModel} from '../../../models/localization-and-pricing/country.model';
import {NavigationModel} from '../../../models/localization-and-pricing/navigation.model';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.css']
})
export class VerifyEmailComponent implements OnInit {

  disabled = true;
  message: string = null;

  constructor(private userSv: UserService,
              private modalSv: ModalService,
              private route: ActivatedRoute,
              private router: Router,
              private tSv: TranslateService) { }

  ngOnInit() {

    this.route.params.subscribe((params: Params) => {
      const token = params['token'];

      const expired = TokenModel.isExpired(token);

      if (expired === true) {

        this.message = 'verifyEmail.emailExpired';
        this.disabled = false;
        return ;
      }

      this.userSv.verifyEmail(token).subscribe((user) => {

        this.disabled = false;
        this.message = 'verifyEmail.successMessage';
        this.modalSv.showAlertModal(this.tSv.instant('verifyEmail.success'),
          this.tSv.instant('verifyEmail.successMessage')).subscribe((response) => {

            // DNavigates to the default url path
            this.router.navigate(NavigationModel.getHomeURLPaths(['landing']));

        });

        const currentUser = UserModel.getCurrent();
        if (currentUser !== null && currentUser !== undefined) {
          currentUser.isEmailVerified = true;
          UserModel.setCurrent( currentUser );
        }

      }, (error: ErrorModel) => {
        this.message = error.message;
        this.disabled = false;
      });

    });

  }

  onHomeClick() {

    // No need to ehck if home page culture and country exists handled in the function
    this.router.navigate(NavigationModel.getHomeURLPaths(['landing']));

  }

}
